import { render, staticRenderFns } from "./villagePlan.vue?vue&type=template&id=2872401e&scoped=true&"
import script from "./villagePlan.vue?vue&type=script&lang=js&"
export * from "./villagePlan.vue?vue&type=script&lang=js&"
import style0 from "./villagePlan.vue?vue&type=style&index=0&id=2872401e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2872401e",
  null
  
)

export default component.exports